import React from 'react';
import Icon, { type IconName } from '../icons/Icon';

interface EmptyStateProps {
  icon?: IconName;
  title: string;
  /**
   * Say what would appear here once there is data, not just "no data" — an
   * empty panel is the first thing a new operator sees, so it is the cheapest
   * onboarding surface in the console.
   */
  description: string;
  action?: { label: string; onClick: () => void };
  secondaryAction?: { label: string; onClick: () => void };
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon = 'inbox',
  title,
  description,
  action,
  secondaryAction,
  className = '',
}) => (
  <div
    className={`flex flex-col items-center justify-center rounded-card border border-dashed border-border-default bg-surface px-6 py-14 text-center ${className}`}
  >
    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-surface-sunken text-ink-3">
      <Icon name={icon} className="h-5 w-5" />
    </span>
    <h3 className="mt-4 text-base font-semibold text-ink">{title}</h3>
    <p className="mt-1.5 max-w-md text-sm leading-6 text-ink-2">{description}</p>
    {action || secondaryAction ? (
      <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
        {action ? (
          <button
            type="button"
            onClick={action.onClick}
            className="rounded-lg bg-brand-blue px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-brand-blue-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2"
          >
            {action.label}
          </button>
        ) : null}
        {secondaryAction ? (
          <button
            type="button"
            onClick={secondaryAction.onClick}
            className="rounded-lg border border-border-default px-4 py-2 text-sm font-semibold text-ink-2 transition-colors hover:bg-surface-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2"
          >
            {secondaryAction.label}
          </button>
        ) : null}
      </div>
    ) : null}
  </div>
);

export default EmptyState;
